import React from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import swal from 'sweetalert';
import '../../../../../styles/components/addfundmodal.scss';
import { Plus, Trash2 } from 'lucide-react';
import { addFund } from '../services/auctionApprovalServices';
import i18n from '../../../../../i18n';
import FileInputNew from '../../../../helpers/fileInputNew';
import { getAuctionsList, getWinnersList } from '../../../../../models/auctions';

const selectStylesPop = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '.4rem',
    borderColor: state.isFocused ? '#1b8f9b' : '#e0e0e0',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(27, 143, 155, 0.1)' : 'none',
    '&:hover': {
      //   borderColor: '#1b8f9b',
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#1b8f9b'
      : state.isFocused
        ? 'rgba(27, 143, 155, 0.1)'
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    zIndex: 2,
  }),
  singleValue: (provided) => ({
    ...provided,
    textAlign: 'left',
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 99999 }),
};

export class AuctionAddFundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'offline', // 'offline' or 'wallet'
      is_loading: false,
      input: {},
      errors: {},
      selectedAuction: null,
      selectedWinner: null,
      auctions: [],
      bidders: [],
      fileInputs: [],
      file_receipt: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.group && this.props.group.id !== prevProps.group?.id) {
      this.getAuctions();
      this.resetModalState();
    }
  }

  // helper to clear modal state
  resetModalState = () => {
    this.setState({
      selectedAuction: null,
      selectedWinner: null,
      auctions: [],
      bidders: [],
      input: {},
      errors: {},
      fileInputs: [],
      file_receipt: null,
    });
  };

  async getAuctions() {
    let { group } = this.props;
    let q = group ? `groupId=${group.id}&deliveryStatus=2` : '';
    if (!group) {
      return;
    }
    const response = await getAuctionsList(q);
    if (response.success) {
      const auctions = response.data.map((a) => ({
        value: a.id,
        label: a.title,
      }));
      this.setState({ auctions });
    } else {
      // this.setState({ loading: false });
    }
  }

  async getBidders() {
    let { auction } = this.state.input;
    let q = auction ? `auctionId=${auction}` : '';
    if (!auction) {
      return;
    }
    const response = await getWinnersList(q);
    if (response.success) {
      const bidders = response.data.map((item) => ({
        value: item.id,
        label: `${item.name || ''}  - ${item.bid_amount}`,
      }));
      this.setState({ bidders });
    } else {
      // this.setState({ loading: false });
    }
  }

  handleTabChange = (tab) => {
    this.setState({
      activeTab: tab,
      input: { group: this.state.input.group },
      errors: {},
      file_receipt: null,
      fileInputs: [],
    });
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  onFileChange = (event) => {
    if (event.target.name === 'file_receipt') {
      this.setState({ file_receipt: event.target.files[0] });
    }
  };

  onFileChangeNew = (e, index) => {
    const updatedInputs = [...this.state.fileInputs];
    updatedInputs[index].file = e.target.files[0];
    this.setState({ fileInputs: updatedInputs });
  };

  addNewFileInput = () => {
    this.setState((prevState) => ({
      fileInputs: [...prevState.fileInputs, { id: prevState.fileInputs.length + 1, file: null }],
    }));
  };

  removeFile = (index) => {
    this.setState((prevState) => ({
      fileInputs: prevState.fileInputs.filter((_, i) => i !== index),
    }));
  };

  validateOfflineForm = () => {
    const required = [
      'payment_date',
      'user',
      'credit',
      'account_number',
      'bank',
      'receipt_number',
      'remarks',
    ];

    for (let field of required) {
      if (!this.state.input[field]) {
        return false;
      }
    }
    return this.state.file_receipt !== null;
  };

  validateWalletForm = () => {
    const required = ['auction', 'user', 'remarks'];

    for (let field of required) {
      if (!this.state.input[field]) {
        return false;
      }
    }
    return this.state.file_receipt !== null;
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { group } = this.props;

    const isValidOffline = this.state.activeTab === 'offline' && this.validateOfflineForm();
    const isValidWallet = this.state.activeTab === 'wallet' && this.validateWalletForm();
    console.log(isValidOffline, isValidWallet, 'ytyt');

    if (!isValidOffline && !isValidWallet) {
      swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error');
      return;
    }

    try {
      this.setState({ is_loading: true });
      let { fileInputs } = this.state;
      const formData = new FormData();

      // Common fields

      formData.append('user', this.state.input.user);
      formData.append('auction', this.state.input.auction);
      formData.append('group', group.id);
      formData.append('remarks', this.state.input.remarks);

      if (this.state.activeTab === 'offline') {
        formData.append('client_payment', 'offline');
        formData.append('credit', this.state.input.credit);
        formData.append('account_number', this.state.input.account_number);
        formData.append('bank', this.state.input.bank);
        formData.append('receipt_number', this.state.input.receipt_number);
        formData.append('payment_date', this.state.input.payment_date);
        formData.append('method', 'offline');
      } else {
        formData.append('client_payment', 'swap');
      }

      if (this.state.file_receipt) {
        formData.append('attachment', this.state.file_receipt, this.state.file_receipt.name);
      }

      if (fileInputs.length > 0) {
        fileInputs.forEach((input, index) => {
          if (input.file) {
            formData.append(`additional_attachments${index}`, input.file, input.file.name);
          }
        });
      }

      const response = await addFund(formData);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('fund_added'), 'success');
        this.setState({ is_loading: false });
        this.props.onClose();
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ is_loading: false });
    }
  }

  handleAuctionChange = (selectedAuction) => {
    let input = { ...this.state.input, auction: selectedAuction.value };
    this.setState({ selectedAuction, selectedWinner: null, input }, () => {
      this.getBidders();
    });
  };
  handleWinnerChange = (selectedWinner) => {
    this.setState({ selectedWinner });
  };

  renderOfflineForm = () => {
    const { input, errors, auctions, bidders, selectedAuction, selectedWinner } = this.state;

    return (
      <div className="wallet-form-content">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('auction')}</label>
            <Select
              value={selectedAuction}
              options={auctions}
              onChange={this.handleAuctionChange}
              styles={selectStylesPop}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              className="wallet-select"
              placeholder={i18n.t('select_auction')}
            />
            <div className="wallet-error">{errors.auction}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('bidder')}</label>
            <Select
              value={selectedWinner}
              options={bidders}
              onChange={(e) => {
                let newInput = { ...input, user: e.value };
                this.setState({ input: newInput, selectedWinner: e });
              }}
              styles={selectStylesPop}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              className="wallet-select"
              placeholder={i18n.t('select_bidder')}
              isDisabled={!selectedAuction}
            />
            <div className="wallet-error">{errors.user}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('payment_date')}</label>
            <input
              type="date"
              name="payment_date"
              value={input.payment_date || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder="hello"
            />
            <div className="wallet-error">{errors.payment_date}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('amount')}</label>
            <input
              type="text"
              name="credit"
              value={input.credit || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('enter_amount')}
            />
            <div className="wallet-error">{errors.credit}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('account_number')}</label>
            <input
              type="text"
              name="account_number"
              value={input.account_number || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('enter_account_number')}
            />
            <div className="wallet-error">{errors.account_number}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('bank')}</label>
            <input
              type="text"
              name="bank"
              value={input.bank || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('enter_bank_name')}
            />
            <div className="wallet-error">{errors.bank}</div>
          </div>

          <div className="col-md-12 mb-3">
            <label className="wallet-form-label">{i18n.t('receipt')}</label>
            <input
              type="text"
              name="receipt_number"
              value={input.receipt_number || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('enter_receipt_number')}
            />
            <div className="wallet-error">{errors.receipt_number}</div>
          </div>
        </div>
      </div>
    );
  };

  renderWalletForm = () => {
    const { auctions, input, errors, bidders, selectedAuction, selectedWinner } = this.state;

    return (
      <div className="wallet-form-content">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('auction')}</label>
            <Select
              options={auctions}
              onChange={this.handleAuctionChange}
              styles={selectStylesPop}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              className="wallet-select"
              placeholder={i18n.t('select_auction')}
              value={selectedAuction}
            />
            <div className="wallet-error">{errors.auction}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('bidder')}</label>
            <Select
              options={bidders}
              onChange={(e) => {
                let newInput = { ...input, user: e.value };
                this.setState({ input: newInput, selectedWinner: e });
              }}
              styles={selectStylesPop}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              className="wallet-select"
              placeholder={i18n.t('select_bidder')}
              value={selectedWinner}
            />
            <div className="wallet-error">{errors.user}</div>
          </div>
        </div>
      </div>
    );
  };

  renderFileUpload = () => {
    const { fileInputs, activeTab } = this.state;

    return (
      <div className="wallet-file-section">
        <div className="mb-3">
          <label className="wallet-form-label">
            {activeTab === 'offline' ? i18n.t('receipt') : i18n.t('attachment')}
          </label>
          <div className="wallet-file-input-wrapper">
            <FileInputNew
              wrapperClass="wallet-file-input"
              placeholder={i18n.t('choose_file')}
              id="file_receipt"
              name="file_receipt"
              onChange={this.onFileChange}
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf"
            />
          </div>
        </div>
        {/* Additional files - only for offline tab */}
        {activeTab === 'offline' && (
          <div className="wallet-additional-files">
            <label className="wallet-form-label">{i18n.t('additional_doc')}</label>
            {fileInputs.map((input, index) => (
              <div key={input.id} className="wallet-file-row mb-2">
                <div className="wallet-file-input-container">
                  <FileInputNew
                    wrapperClass="wallet-file-input"
                    className="form-control"
                    placeholder={i18n.t('choose_file')}
                    name="file_receipt_addl"
                    id={`file_receipt_addl_${index}`}
                    onChange={(e) => this.onFileChangeNew(e, index)}
                  />
                  <button
                    type="button"
                    className="wallet-remove-file-btn"
                    onClick={() => this.removeFile(index)}
                    title="Remove file"
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
              </div>
            ))}
            <button className="wallet-add-file-btn" onClick={this.addNewFileInput} type="button">
              {/* <i className="fa fa-plus" /> */}
              <Plus size={20} />
              <span>{i18n.t('add_new')}</span>
            </button>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { show, onClose } = this.props;
    const { activeTab, is_loading, input, selectedWinner } = this.state;

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        dialogClassName="wallet-modal-dialog"
        className="wallet-fund-modal"
      >
        <Modal.Header closeButton className="wallet-modal-header">
          <Modal.Title className="wallet-modal-title">
            <i className="fa fa-wallet mr-2"></i>
            {i18n.t('add_fund')} - {i18n.t('client_payment')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="wallet-modal-body">
          {/* Tab Navigation */}
          <div className="wallet-tab-navigation">
            <button
              className={`wallet-tab-btn ${activeTab === 'offline' ? 'active' : ''}`}
              onClick={() => this.handleTabChange('offline')}
              type="button"
            >
              {i18n.t('offline_payment')}
            </button>
            <button
              className={`wallet-tab-btn ${activeTab === 'wallet' ? 'active' : ''}`}
              onClick={() => this.handleTabChange('wallet')}
              type="button"
            >
              {i18n.t('wallet_payment')}
            </button>
          </div>

          {/* Form Content */}
          <div className="wallet-form-container">
            <form className="wallet-form" autoComplete="off">
              {activeTab === 'offline' ? this.renderOfflineForm() : this.renderWalletForm()}

              {/* File Upload Section */}
              {this.renderFileUpload()}

              {/* Remarks Section */}
              <div className="wallet-remarks-section">
                <label className="wallet-form-label">{i18n.t('remarks')}</label>
                <textarea
                  name="remarks"
                  value={input.remarks || ''}
                  onChange={this.handleChange}
                  rows={4}
                  className="wallet-textarea"
                  placeholder={i18n.t('enter_remarks')}
                />
              </div>

              {/* Action Buttons */}
              <div className="wallet-actions">
                <button type="button" className="wallet-btn wallet-btn-cancel" onClick={onClose}>
                  {i18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="wallet-btn wallet-btn-submit"
                  onClick={this.handleSubmit}
                  disabled={is_loading || !selectedWinner}
                >
                  {is_loading && <i className="fa fa-spinner fa-spin mr-2"></i>}
                  {i18n.t('submit')}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
